/**
 * QUI PORTE LES PARAMÈTRES DE GRAPHE DANS SON URL (DEV-1508 lot 2c).
 *
 * INTENTION : l'URL d'une page décrit ce que cette page montre. Sur la page de
 * données standard, `freq`, `date_from`, `date_to`, `graph` et `action` sont
 * exactement cela : la période et le pas choisis dans le sélecteur, partageables
 * par un lien. C'est un service rendu, on n'y touche pas.
 *
 * Le store des graphiques est PARTAGÉ : il est créé dès qu'une page l'appelle,
 * et son surveillant de période écrit ces paramètres dans l'URL à la première
 * exécution, immédiate. Une page qui a besoin du store pour une autre raison —
 * la page « Données du compteur » ne s'en sert que pour porter l'identifiant du
 * compteur courant, que le composable des workflows relit — se voyait donc
 * décorer d'une période de trois mois et d'une fréquence brute qu'elle n'utilise
 * pas et que personne n'avait choisies (staging, 10/09 :
 * `?freq=raw&date_from=2026-06-10&date_to=2026-09-10&action=true` apparu tout
 * seul). Une URL qui ment sur ce qu'elle montre se partage et se garde.
 *
 * Ce module dit, sur le seul chemin, qui porte ces paramètres. Rien d'autre :
 * il ne décide ni du chargement ni de l'affichage.
 */

/**
 * Les chemins qui NE portent PAS les paramètres de graphe. Un fragment suffit :
 * les routes de la fiche source sont préfixées par `/source/:_id_source/`.
 */
const CHEMINS_SANS_PARAMETRES_DE_GRAPHE = [
    /** L'adresse « ombre » de la page « Données du compteur » Enedis. */
    "/donnees-compteur",
]

/**
 * Vrai quand l'URL de ce chemin doit porter `freq`, `date_from`, `date_to`,
 * `graph` et `action`. Vrai par défaut : c'est le comportement historique, et
 * seules les pages listées ci-dessus s'en écartent.
 *
 * LE CHEMIN NE SUFFIT PLUS (DEV-1508 lot 3c). `/source/<id>/data` rend deux
 * pages différentes selon l'interrupteur `ENEDIS_PAGE_DONNEES_V2` : la page de
 * données standard, qui porte son sélecteur de période et mérite son lien
 * partageable, ou la page « Données du compteur », qui n'a pas de sélecteur et
 * n'a jamais choisi ces trois mois. Armée, la route standard se voyait donc
 * décorer de `?freq=raw&date_from=2026-06-11&date_to=2026-09-11&action=true`
 * (staging, 11/09) — la période héritée du store, que la page n'utilise plus.
 *
 * D'où le second paramètre : `pageCompteurV2Servie` dit que ce chemin, ce
 * coup-ci, rend la page v2. Absent, rien ne change — l'interrupteur désarmé
 * laisse l'URL strictement celle d'avant (E11).
 */
export function urlPorteLesParametresDeGraphe(
    chemin: string,
    pageCompteurV2Servie = false
): boolean {
    if (pageCompteurV2Servie) return false
    return !CHEMINS_SANS_PARAMETRES_DE_GRAPHE.some((sans) =>
        chemin.includes(sans)
    )
}
